import { useNavigate } from "react-router-dom";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { REPORTS_CATALOG } from "@/lib/nav";
import { ChevronRight } from "lucide-react";

export default function ReportsHub() {
    const navigate = useNavigate();
    return (
        <>
            <PageHeader kicker="REPORTS" title="Reports" subtitle="Financial statements, receivables, payables, taxes, inventory, and audit. Drill into any number." />
            <PageBody>
                <div className="space-y-6">
                    {REPORTS_CATALOG.map((g) => (
                        <div key={g.group}>
                            <h3 className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mb-3">{g.group}</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                {g.items.map((r) => (
                                    <button key={r.to} onClick={() => navigate(r.to)} className="text-left bg-card border border-border rounded-md p-5 hover:border-gold/40 transition-all" data-testid={`report-${r.name.toLowerCase().replace(/\W+/g, '-')}`}>
                                        <div className="flex items-center justify-between">
                                            <div className="text-[15px] font-semibold">{r.name}</div>
                                            <ChevronRight className="w-4 h-4 text-muted-foreground" />
                                        </div>
                                        <div className="text-[12px] text-muted-foreground mt-1">{r.desc}</div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </PageBody>
        </>
    );
}
